export default __webpack_public_path__ + "static/media/placeholder_private03-it-mobile.b93fc508.png";